module.exports = __webpack_public_path__ + "static/media/country_bi.89e6d98f.webp";